<template>
    <div class="productSpecificationMain" @click.self="consoleInfo('main click')">
        <div class="frame">
            <div class="productSpecificationListFrameHeader">
                <img :src="getImgUrl(specificationList[specificationSelectedIndex].pictures)" />
                <div class="verticalGully" />
                <div class="price">
                    ￥{{ parseFloat(specificationList[specificationSelectedIndex].specificationPrice.toFixed(2)) }}
                </div>
            </div>
            <div class="horizonGully" style="flex-shrink:0;"/>
            <div class="horizonDivider" style="flex-shrink:0;"/>
            <div class="horizonGully" style="flex-shrink:0;"/>

            <div class="productSpecificationListFrameContent">
                <div
                    v-for="(
                        { pictures, specificationName }, index
                    ) of specificationList"
                    :key="index"
                    :class="specificationItemClass(index)"
                    @click="specificationSelectedIndex = index"
                >
                    <div style="display: flex; align-items: center">
                        <img
                            class="specificationImg"
                            :src="getImgUrl(pictures)"
                        />
                        <span>{{ specificationName }}</span>
                    </div>
                </div>
            </div>

            <div class="productSpecificationListFrameBottom">
                <div class="horizonGully" />
                <div class="horizonDivider" />
                <div class="horizonGully" />

                <div style="display: flex;align-items: center;">
                    <div style="flex-shrink:0;">
                        购买数量
                    </div>
                    <div style="flex-grow: 1;" />
                    <ProductIncAndDesc class="productIncAndDesc" :maxBuyNum="checkMaxBuyNum(shopId, productId, specificationList[specificationSelectedIndex].id)" :maxNumber="specificationList[specificationSelectedIndex].stock" v-model="purchaseNumber" />
                </div>

                <div class="horizonGully" />
                <div class="horizonDivider" />
                <div class="horizonGully" />
                    <div ref="addToCartView">
                        <button
                            class="operateButton"
                            :disabled="ifDirectPurchase && (minimallyBuyPrice > purchaseNumber * parseFloat(specificationList[specificationSelectedIndex].specificationPrice.toFixed(2)) || shopInfo.ifBusiness == 1)"
                            @click="confirm"
                            >{{confirmDescription}}</button>
                    </div>
                    <div class="horizonGully"/>
                    <button
                        style="flex-shrink: 0;"
                        class="operateButton"
                        @click="removeDialog"
                        >关闭</button
                    >
            </div>
        </div>

        <BaseParabolaAnimate ref="addToCartAnimate" :imgPic="getImgUrl(productImg)"/>
    </div>
</template>

<script>
//
import { mapState, mapGetters, } from 'vuex'

//
//
import ProductIncAndDesc from '@/components/shop/ProductIncAndDesc.vue'

//
import store from '@/store'
import router from '@/router'

export default {
    store: store,
    router: router,

    components: {
        ProductIncAndDesc,
    },

    name: 'ProductSpecification',

    props: {
        shopId: {
            type: Number,
            required: true,
        },

        productId: {
            type: Number,
            required: true,
        },

        productName: {
            type: String,
            required: true,
        },

        productImg: {
            type: String,
            required: true,
        },

        minimallyBuyPrice: {
            type: Number,
            default: 0,
        },

        specificationList: {
            type: Array,
            default: () => {
                return [
                    {
                        id: '',
                        pictures: '', //
                        productId: '',
                        specificationMsg: '',
                        specificationName: '', //
                        specificationPrice: '', //
                        stock: 0,
                    },
                ]
            },
        },

        ifDirectPurchase: {
            type: Boolean,
            default: false,
        },

        shelfId: {
            default: () => {
                return [];
            },
        },
    },

    computed: {
        ...mapState({
            shopInfo: (state) => state.shop.shopInfo,
            cartInfoAll: (state) => state.cart.cartInfoAll,
        }),

        ...mapGetters('cart', [
            'getCartInfo',
        ]),

        cartInfo() {
            if(this.cartInfoAll && process.env.NODE_ENV == 'development')
            {
                console.log('productSpecification, cartInfoAll changed')
            }

            //
            return this.getCartInfo(this.shopId);
        },

        confirmDescription()
        {
            //
            if(this.ifDirectPurchase)
            {
                //
                if(this.shopInfo.ifBusiness == 1)
                {
                    return '店铺已暂停营业'
                }

                //
                if(this.minimallyBuyPrice <= this.purchaseNumber * parseFloat(this.specificationList[this.specificationSelectedIndex].specificationPrice.toFixed(2)))
                {
                    return '确认'
                }

                return `差${this.minimallyBuyPrice - this.purchaseNumber * parseFloat(this.specificationList[this.specificationSelectedIndex].specificationPrice.toFixed(2))}元起送`
            }

            return '加入购物车';
        },
    },

    data() {
        return {
            specificationSelectedIndex: 0,

            purchaseNumber: 1,
        }
    },

    created() {},

    methods: {
        specificationItemClass(index) {
            return this.specificationSelectedIndex == index
                ? 'specificationItemSelected'
                : 'specificationItem'
        },

        removeDialog() {
            this.remove()
        },

        commitOrder() {
            //
            this.payApiCommitOrder(this.shopId, [{
                productInfo:
                {
                    pId: this.productId,
                    pPic_1: this.specificationList[this.specificationSelectedIndex].pictures,
                    pName: this.productName,
                    pNowPrice: parseFloat(this.specificationList[this.specificationSelectedIndex].specificationPrice.toFixed(2)),
                },
                specificationId: this.specificationList[this.specificationSelectedIndex].id,
                specificationName: this.specificationList[this.specificationSelectedIndex].specificationName,
                snum: this.purchaseNumber,
            }], 0)

            //
            this.removeDialog();
        },

        confirm() {
            if (this.ifDirectPurchase) {
                return this.commitOrder()
            }

            this.$refs.addToCartAnimate.addToCartAnimate(this.$refs.addToCartView, document.getElementById("componentCartIcon"));

            this.cartApiAddToCart(
                this.shopId,
                this.specificationList[this.specificationSelectedIndex].id,
                this.purchaseNumber,
                this.productId,
                '成功加入购物车',
            )
        },
    },
}
</script>

<style lang="scss" scoped>
$productSpecificationListFrameWidth: 85vw;
$productSpecificationListFrameHeight: 85vh;

//
.productSpecificationMain {
    z-index: 1990;
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    display: flex;
    background-color: rgba(0, 0, 0, 0.7);;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: $fontSizeContent;
    line-height: 2em;
}

.frame {
    display: flex;
    flex-direction: column;
    width: $productSpecificationListFrameWidth;
    height: $productSpecificationListFrameHeight;
    background: #ffffff;
    border-radius: $borderRadius;
    box-sizing: border-box;
    padding: $padding;
}

//
.productSpecificationListFrameHeader {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    img {
        width: 4em;
        height: 4em;
        box-sizing: border-box;
        overflow: hidden;
        border-radius: $borderRadius;
    }

    .price {
        font-size: 2em;
        color: red;
    }
}

//
.productSpecificationListFrameContent {
    flex-grow: 1;
    overflow: auto;

    //
    .specificationItem {
        display: inline-block;
        box-sizing: border-box;
        margin: $margin;
        padding: $padding;
        border-radius: $borderRadius;
        border: 0.01rem solid #b9b8b800;
        background: #f8f7f7;

        .specificationImg {
            width: 3em;
            height: 3em;
            margin-right: $margin;
        }
    }

    .specificationItemSelected {
        @extend .specificationItem;

        border: 0.01rem solid #e53e27;
        color: #e53e27;
    }
}

//
.productSpecificationListFrameBottom {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;

    .productIncAndDesc
    {
        width: 6em;
        flex-shrink: 0;
    }

    .specificationPrice
    {
        color: #e53e27;
    }

    .operateButton
    {
        width: 100%;
    }
}

</style>